import React from 'react';
import * as C from "../componentsM/index";
import first from '../assets/png (2).png';
import second from '../assets/uocie.jpg';
import third from '../assets/edexcel-icon-100x100.jpg';
import firstfourth from '../assets/png (1).png';
const Accreditation = () => <>

    <C.Hero title={"ACCREDITATION"} image={"/hero/6.jpg"} />


    <section className='p-4 md:p-24'>


        <img src={first} />

        <h6 className='font-semibold'>Authorised for Middle Years Programme in 1996</h6>
        <h6 className='font-semibold'>Authorised for Diploma Programme in 2001</h6>
        <h6 className='font-semibold'>Authorised for Primary Years Programme in 2014</h6>


        <h1 className='font-semibold md:text-2xl text-xl mt-20'>Associations</h1>


        <img src={second} />

        <h1 className='font-semibold md:text-2xl text-xl mt-20'>Registered for IGCSE in 2004</h1>


        <img src={third}/>


        <h1 className='font-semibold md:text-2xl text-xl mt-20'>Registered for IGCSE in 2004</h1>
        <img src={firstfourth}/>
    </section>

</>

export default Accreditation